module.exports = __webpack_public_path__ + "img/person4-small@2x.c96b2f02.png";